// Single source of truth for API and WebSocket URLs.
// VITE_API_URL and VITE_WS_URL are set in packages/ui/.env.
// AUTH_BACKEND is always the same as BACKEND (no separate auth origin).
//
// In development, VITE_API_URL should be empty so browser-side fetch calls
// use relative paths (e.g., /api/v1/...) that go through the Vite proxy.
// The || fallback only applies when the env var is missing entirely.
export const apiBaseUrls = {
  BACKEND:
    import.meta.env.VITE_API_URL !== undefined
      ? import.meta.env.VITE_API_URL
      : "http://127.0.0.1:8000",
  WS: import.meta.env.VITE_WS_URL || "ws://127.0.0.1:8000",
};

export const endpoints = {};

const links = {};

export default links;

export const ws_endpoints = {
  delete_project_status: "delete_project_status",
  delete_application_status: "delete_application_status",
  application_deployment_status: "deployment_status",
  application_status: "application_status",
};
